import React from "react";
import {useSiteRentalTypesQueryQuery} from "../../generated/graphql";
import {GraphQlSelect} from "./GraphQlSelect";

export const SiteRentalTypeSelect = (props) => {
    const query = useSiteRentalTypesQueryQuery();
    return <GraphQlSelect {...props} queryResult={query} labelField="label"/>;
}
